import Store from 'lightningjs-redux';
import { getCSAPicto } from '../../../../../../../logic/player/player.selectors';

const mapControllers = instance => [
  {
    selector: getCSAPicto,
    callback: value => {
      instance.csaPicto = value;
    },
    shouldBeInvokedOnConnect: true,
  },
];

export default Store.control(mapControllers);
